import { gql } from '@apollo/client';

export const ACCOUNT_BALANCE_STATS = gql`
  query getProgram($id: ID!, $currentPeriodAccountStats: Boolean) {
    programV2(id: $id, currentPeriodAccountStats: $currentPeriodAccountStats) {
      id
      merchant {
        id
        companyName
        companyUrl
        companyImgUrl
      }
      accountBalanceStats {
        adminRate
        adminRateStartDate
        adminRateEndDate
        minUsageFee
        managementFee
        validUntilDate
        validStartDate
        minBalanceRequired
        warningBalance
        useRateSettings
        newUseTieredRate {
          id
          newAdminAfterTierRate
          newAdminTierCommission
          newAdminTierRate
        }
      }
      enableNewStats
      salesTaxRate
      accountStat{
        id
        programId
        startDate
        endDate
        adminRate
        minUsageFee
        useRateSettings
        minBalanceRequired
        activeCategories
        managementFee {
          banking
          businesses
          creditCards
          creditReporting
          crypto
          insurance
          investments
          loans
          mortgage
          realEstate
          taxServices
          planning
        }
        newUseTieredRate {
          id
          newAdminAfterTierRate
          newAdminTierCommission
          newAdminTierRate
        }
      }
    }
}
`;
